import { NgModule } from '@angular/core';
import { BasicModule } from 'src/app/basic.module';
import { FmesFmtGuideModal } from './fmes-fmt-guide';
import { FtInfomationModalModule } from '@fitt-lib/modals/ft-infomation/ft-infomation.module'

@NgModule({
  declarations: [
    FmesFmtGuideModal
  ],
  imports: [
    BasicModule,
    FtInfomationModalModule
  ],
  entryComponents: [
    FmesFmtGuideModal
  ]
})
export class FmesFmtGuideModalModule { }
